import { SpecialProductsListing } from '../../../components/product/SpecialProductsListing/SpecialProductsListing';
import { useTranslation } from '../../../i18n/i18n';
import { useRef, useState, KeyboardEvent, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSession } from '../../../state/session';
import { ApiProduct } from '../../../types';
import './SpecialProductsSearchInput.css';
import { Overlay } from '../../../components/Overlay/Overlay';

export const SpecialProductsSearchInput = (): JSX.Element => {
	const t = useTranslation().search;
	const { specialsProducts } = useSession();
	const [inputValue, setInputValue] = useState('');
	const [searchResults, setSearchResults] = useState<ApiProduct[]>([]);
	const [resultsIndex, setResultsIndex] = useState(-1);
	const [showResults, setShowResults] = useState(false);
	const history = useHistory();
	const input = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const handleClick = (event: MouseEvent) => {
			if (event.target instanceof Element) {
				const inputClicked = event.target.id === 'specials-search-input';
				if (inputClicked) return;
				const clickedListItem = event.target.closest('#autocompletion') !== null;
				setShowResults(clickedListItem);
			}
		};
		document.addEventListener('click', handleClick, true);
		return () => {
			document.removeEventListener('click', handleClick, true);
		};
	}, []);

	useEffect(() => {
		return history.listen((_location, action) => {
			if (action === 'PUSH' || action === 'POP' || action === 'REPLACE') setShowResults(false);
		});
	}, [history]);

	const filterResults = (str: string, products: ApiProduct[]) => {
		if (str === '') return [];
		return products.filter(
			(product) => product.name.toLocaleLowerCase().includes(str) || product.displayId.includes(str)
		);
	};
	const handleFocus = (q: string) => {
		q = q.trim().toLocaleLowerCase();
		setShowResults(true);
		setSearchResults(filterResults(q, specialsProducts));
	};
	const handleChange = (q: string) => {
		setInputValue(q);
		q = q.trim().toLocaleLowerCase();
		setSearchResults(filterResults(q, specialsProducts));
		if (q !== '') setShowResults(true);
	};
	const handleSelectItem = (product: ApiProduct) => {
		setSearchResults([]);
		setResultsIndex(-1);
		history.push('/' + product.perma);
	};

	const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		switch (event.key) {
			case 'Enter':
				const item = searchResults[resultsIndex];
				if (item) handleSelectItem(item);
				setShowResults(false);
				setResultsIndex(-1);
				break;
			case 'ArrowUp':
				setResultsIndex((resultsIndex > 0 ? resultsIndex : searchResults.length) - 1);
				break;
			case 'ArrowDown':
				setResultsIndex((resultsIndex + 1) % searchResults.length);
				break;
		}
	};

	return (
		<div id="special-products-search-input">
			{showResults && searchResults.length > 0 && (
				<Overlay
					toggle={() => setShowResults((prev) => !prev)}
					className="specials-search-overlay"
					onClick={() => setShowResults((prev) => !prev)}
				/>
			)}
			<input
				ref={input}
				placeholder={t.placeholder}
				type="search"
				value={inputValue}
				onFocus={(e) => handleFocus(e.target.value)}
				onChange={(e) => handleChange(e.target.value)}
				onKeyDown={(e) => handleKeyDown(e)}
				id="specials-search-input"
			/>
			<div id="autocompletion" className={showResults ? 'focused' : ''}>
				<SpecialProductsListing products={searchResults} activeIndex={resultsIndex} />
			</div>
		</div>
	);
};
